export const INVESTOR_TYPE = "investorType";
export const SUB_TYPE = "subType"
export const TYPE = "type"
export const TITLE = "title"
export const DATE = "date"
export const YEAR = "year"
export const LINK = "link"
export const DESCRIPTION = "transcriptDescription"
export const UPLOAD_TRANSCRIPT = "transcriptAttachmentId";
export const UPLOAD = "fileAttachmentId";
export const UPLOAD_LOGO = "logoAttachmentId"
export const RATING_TYPE = "ratingType";
export const RATING_NAME = "ratingName";
export const RATING_DESCRIPTION = "ratingDescription";
export const ADDITIONAL_UPLOAD = "additionalUpload";
export const THUMBNAIL_UPLOAD = "thumbnailAttachmentId";

export const INVESTOR_TYPES = [
  { label: "Financials & Reports", value: "Financials & Reports" },
  { label: "Governance & Policies", value: "Governance & Policies" },
  { label: "Shareholders Information", value: "Shareholders Information" },
];

export type InvestorType =
  | "Financials & Reports"
  | "Governance & Policies"
  | "Shareholders Information";

  export const INVESTOR_SUB_TYPES_BY_TYPE: Record<InvestorType, { label: string; value: string }[]> = {
  "Financials & Reports": [
    { label: "Investors Presentation & Press Release", value: "Investors Presentation & Press Release" },
    { label: "Quarterly Results", value: "Quarterly Results" },
    { label: "Annual Reports", value: "Annual Reports" },
    { label: "Annual Return", value: "Annual Return" },
    { label: "Webcast & Transcripts", value: "Webcast & Transcripts" },
    { label: "Credit Ratings", value: "Credit Ratings" },
  ],
  "Governance & Policies": [
    { label: "Policies & Code of Conduct", value: "Policies & Code of Conduct" },
    { label: "Corporate Governance", value: "Corporate Governance" },
    { label: "Advertisements in Newspapers as per Regulation 47(1)", value: "Advertisements in Newspapers as per Regulation 47(1)" },
    { label: "Disclosure under Regulation 46 and 62 of SEBI (LODR)", value: "Disclosure under Regulation 46 and 62 of SEBI (LODR)" },
    { label: "Notices & Disclosures", value: "Notices & Disclosures" },
  ],
  "Shareholders Information": [
    { label: "Related Party Transactions", value: "Related Party Transactions" },
    { label: "Unclaimed Dividend", value: "Unclaimed Dividend" },
    { label: "Shareholding Pattern", value: "Shareholding Pattern" },
    { label: "Secretarial Compliance Report", value: "Secretarial Compliance Report" },
  ],
};


export const TYPES = [
  { label: "Investors Presentation", value: "Investors Presentation" },
  { label: "Press Release", value: "Press Release" },
  { label: "Quarterly Results", value: "Quarterly Results" },
  { label: "Annual Reports", value: "Annual Reports" },
  { label: "Annual Return", value: "Annual Return" },
  { label: "Webcast & Transcripts", value: "Webcast & Transcripts" },
  { label: "Credit Ratings", value: "Credit Ratings" },
  { label: "Policies & Code of Conduct", value: "Policies & Code of Conduct" },
  { label: "Corporate Governance", value: "Corporate Governance" },
  { label: "Advertisements in Newspapers as per Regulation 47(1)", value: "Advertisements in Newspapers as per Regulation 47(1)" },
  { label: "Disclosure under Regulation 46 and 62 of SEBI (LODR)", value: "Disclosure under Regulation 46 and 62 of SEBI (LODR)" },
  { label: "Memorandum of Association and Articles of Association", value: "Memorandum of Association and Articles of Association" },
  { label: "Notices", value: "Notices" },
  { label: "Disclosure of Material Events", value: "Disclosure of Material Events" },
  { label: "Related Party Transactions", value: "Related Party Transactions" },
  { label: "Unclaimed Dividend", value: "Unclaimed Dividend" },
  { label: "Shareholding Pattern", value: "Shareholding Pattern" },
  { label: "Secretarial Compliance Report", value: "Secretarial Compliance Report" },
];